<template>
    <div class="container mx-auto px-4 py-8 mb-24">
      <div class="flex flex-col gap-8 sm:flex-row mt-4">
        <!-- Form Section -->
        <div class="w-full lg:w-1/3 bg-gray-50 p-8 rounded-xl shadow-lg">
            <h2 class="text-xl font-bold text-center mb-6 text-gray-700">Select Fields to Record</h2>
            <form class="space-y-6">
              <div>
                <label for="section" class="block text-lg font-medium mb-2 text-gray-700">Select Section</label>
                <select id="section" name="section" class="w-full border border-gray-300 px-4 py-2 rounded-lg focus:border-geay-500 focus:ring-2 focus:ring-gray-200">
                  <option>All</option>
                  <option value="2019/2020">2019/2020</option>
                  <option value="2020/2021">2020/2021</option>
                  <option value="2021/2022">2021/2022</option>
                </select>
              </div>
              <div>
                <label for="classroom" class="block text-lg font-semibold mb-2 text-gray-700">Select Classroom</label>
                <select id="classroom" name="classroom" class="w-full border border-gray-300 px-4 py-2 rounded-lg focus:border-gray-500 focus:ring-2 focus:ring-gray-200">
                  <option></option>
                  <option value="JS1">JS1</option>
                  <option value="JS2">JS2</option>
                  <option value="JS3">JS3</option>
                  <option value="SS1">SS1</option>
                  <option value="SS2">SS2</option>
                  <option value="SS3">SS3</option>
                </select>
              </div>
              <div>
                <label for="subjects" class="block text-lg font-semibold mb-2 text-gray-700">Select Subjects</label>
                <select id="subjects" name="subjects" class="w-full border border-gray-300 px-4 py-2 rounded-lg focus:border-gray-500 focus:ring-2 focus:ring-gray-200">
                  <option></option>
                  <option value="math">Math</option>
                  <option value="science">Science</option>
                  <option value="history">History</option>
                </select>
              </div>
              <div>
                <input type="file" class="block w-full text-lg border border-gray-300 rounded-lg cursor-pointer bg-gray-50 focus:outline-none">
              </div>
              <div class="flex flex-col md:flex-row gap-2  justify-between items-center">
                <button type="submit" class="py-2 px-4 w-full mt-2 bg-transparent border border-gray-300 text-gray-600 text-center rounded-md">Previous Marks</button>
                <button type="submit" class="py-2 px-4 w-full mt-2 bg-primary text-white text-center rounded-md">Save Marks</button>
              </div>
            </form>
          </div>
  
        <!-- Table Section -->
        <div class="w-full sm:w-1/2 xl:w-3/4">
          <div class="flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-6 mb-6">
            <form class="flex items-center w-full md:w-auto">
              <label for="filter" class="text-lg font-semibold text-gray-500 mr-2">Filter</label>
              <input id="filter" type="text" class="bg-gray-50 border border-gray-300 focus:border-gray-600 outline-none py-2 px-2 text-gray-700 text-sm rounded-md w-full md:w-96" placeholder="Type to search..." required />
              <button type="button" class="py-2 px-3 text-sm font-medium text-white bg-gray-400 rounded-md ml-2">
                Clear
              </button>
            </form>
            <form class="flex items-center w-full md:w-auto">
              <label for="perPage" class="text-lg font-semibold text-gray-500 mr-2">Per Page</label>
              <input id="perPage" type="number" class="bg-gray-50 border border-gray-300 focus:border-gray-600 outline-none py-2 px-2 text-gray-700 text-sm rounded-md w-full md:w-20" required />
            </form>
          </div>
          <div class="bg-white shadow-lg rounded-md overflow-x-auto">
            <table class="min-w-full bg-white rounded-md">
              <thead class="bg-gray-700 text-white h-14">
                <tr>
                  <th class="px-4 py-2 text-left text-md font-semibold">Students</th>
                  <th class="px-4 py-2 text-center text-md font-semibold">Matric No</th>
                  <th class="px-4 py-2 text-center text-md font-semibold">Classroom</th>
                  <th class="px-4 py-2 text-center text-md font-semibold">Section</th>
                  <th class="px-4 py-2 text-center text-md font-semibold">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr class="border-b hover:bg-gray-50">
                  <td class="px-4 py-4">Adeloba Joshua</td>
                  <td class="px-4 py-4 text-center">FIHS/20/2024</td>
                  <td class="px-4 py-4 text-center">JS1</td>
                  <td class="px-4 py-4 text-center">2019/2020</td>
                  <td class="px-4 py-4 text-center flex justify-center space-x-2">
                    <button class="bg-gray-500 text-white px-3 py-2 rounded-lg hover:bg-gray-700 transition duration-300">Edit</button>
                    <button class="bg-red-500 text-white px-3 py-2 rounded-lg hover:bg-red-700 transition duration-300">Delete</button>
                  </td>
                </tr>
                <!-- More rows can be added here -->
              </tbody>
            </table>
          </div>
          <div class="flex justify-center mt-6">
            <nav class="flex items-center space-x-2">
              <button class="px-3 py-2 border border-gray-700 text-gray-700 rounded-lg hover:bg-gray-200 transition duration-300">
                <span class="sr-only">Previous</span>
                <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd" />
                </svg>
              </button>
              <button class="px-4 py-2 bg-gray-700 text-white font-semibold rounded-lg">1</button>
              <button class="px-4 py-2 border border-gray-700 text-gray-700 rounded-lg hover:bg-gray-200 transition duration-300">2</button>
              <button class="px-4 py-2 border border-gray-700 text-gray-700 rounded-lg hover:bg-gray-200 transition duration-300">3</button>
              <button class="px-3 py-2 border border-gray-700 text-gray-700 rounded-lg hover:bg-gray-200 transition duration-300">
                <span class="sr-only">Next</span>
                <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                </svg>
              </button>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </template>
  
<script setup lang="ts">
</script>
  
  <style scoped>

  </style>
  
